
export default function AboutSection() {
  const stats = [
    { number: '500+', label: 'Proyectos Completados' },
    { number: '250%', label: 'ROI Promedio' },
    { number: '5+', label: 'Años de Experiencia' },
    { number: '50+', label: 'Herramientas de IA' }
  ];

  const team = [
    {
      name: 'María González',
      role: 'CEO & Marketing Strategist',
      image: 'https://public.readdy.ai/ai/img_res/36ba14fa308a748c37d941a35b4825ab.jpg',
      expertise: ['Estrategia Digital', 'Growth Hacking', 'Business Intelligence']
    },
    {
      name: 'Carlos Ruiz',
      role: 'AI & Data Specialist',
      image: 'https://readdy.ai/api/search-image?query=Professional%20hispanic%20man%20AI%20specialist%20in%20tech%20environment%2C%20data%20scientist%20with%20modern%20business%20casual%20attire%2C%20clean%20corporate%20headshot%20with%20technology%20background&width=400&height=400&seq=ai-carlos&orientation=squarish',
      expertise: ['Machine Learning', 'Marketing Automation', 'Predictive Analytics']
    },
    {
      name: 'Ana López',
      role: 'Creative Director',
      image: 'https://readdy.ai/api/search-image?query=Professional%20hispanic%20woman%20creative%20director%20in%20modern%20design%20studio%2C%20artistic%20professional%20with%20contemporary%20style%2C%20clean%20headshot%20with%20creative%20workspace%20background&width=400&height=400&seq=creative-ana&orientation=squarish',
      expertise: ['Content Creation', 'Brand Design', 'Social Media']
    },
    {
      name: 'David Martín',
      role: 'Technical Lead',
      image: 'https://readdy.ai/api/search-image?query=Professional%20hispanic%20man%20technical%20lead%20developer%2C%20software%20engineer%20with%20modern%20casual%20business%20attire%2C%20clean%20corporate%20headshot%20with%20technology%20elements%20in%20background&width=400&height=400&seq=tech-david&orientation=squarish',
      expertise: ['Web Development', 'SEO Technical', 'Analytics Implementation']
    }
  ];

  return (
    <section id="nosotros" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            Sobre DigitalAI
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Somos una agencia especializada en marketing digital potenciado por inteligencia artificial. 
            Nuestro equipo combina experiencia en marketing con tecnología de vanguardia.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <h3 className="text-3xl font-bold text-gray-800 mb-6">
              Transformamos tu negocio con IA
            </h3>
            <p className="text-gray-600 mb-6">
              En DigitalAI, no solo implementamos estrategias de marketing digital tradicionales. 
              Utilizamos inteligencia artificial para automatizar procesos, optimizar campañas en tiempo real 
              y generar insights que impulsan el crecimiento de tu negocio.
            </p>
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-check-line text-blue-600"></i>
                </div>
                <span className="text-gray-700">Automatización inteligente de campañas</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-check-line text-blue-600"></i>
                </div>
                <span className="text-gray-700">Análisis predictivo de mercado</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-check-line text-blue-600"></i>
                </div>
                <span className="text-gray-700">Personalización a escala</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-check-line text-blue-600"></i>
                </div>
                <span className="text-gray-700">ROI medible y transparente</span>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://readdy.ai/api/search-image?query=Modern%20digital%20marketing%20agency%20team%20working%20with%20AI%20technology%2C%20diverse%20professionals%20collaborating%20around%20advanced%20computer%20screens%20showing%20data%20analytics%20and%20artificial%20intelligence%20interfaces%2C%20contemporary%20office%20environment%20with%20blue%20and%20purple%20accent%20lighting&width=600&height=500&seq=team-work&orientation=landscape"
              alt="Equipo trabajando con IA"
              className="rounded-2xl shadow-2xl object-cover w-full h-96"
            />
            <div className="absolute -bottom-6 -right-6 bg-gradient-to-r from-blue-600 to-purple-600 rounded-2xl p-6 text-white">
              <div className="text-2xl font-bold">5+ años</div>
              <div className="text-sm opacity-90">liderando la innovación</div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <div className="text-4xl font-bold text-blue-600 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
